import React from "react";
import SimpleGrid, { SimpleGridProps } from "../grid/SimpleGrid";

export default function PageGridContainer(props: SimpleGridProps) {
  return <SimpleGrid maxWidth="1224px" spacingX={6} px={[4, 4, 4, 4, 0]} mx="auto" {...props} />;
}
